var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.0818,
    fill: "#A81D22",
    stroke: "white",
    strokeWidth: 1.83639
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.5C12.5 16.5796 13.2462 15.8334 14.1667 15.8334H14.9414C15.4986 15.8334 16.019 15.5549 16.3281 15.0912L17.0052 14.0755C17.3143 13.6119 17.8347 13.3334 18.392 13.3334H21.608C22.1653 13.3334 22.6857 13.6119 22.9948 14.0755L23.6719 15.0912C23.981 15.5549 24.5014 15.8334 25.0586 15.8334H25.8333C26.7538 15.8334 27.5 16.5796 27.5 17.5V25C27.5 25.9205 26.7538 26.6667 25.8333 26.6667H14.1667C13.2462 26.6667 12.5 25.9205 12.5 25V17.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 20.8334C22.5 22.2141 21.3807 23.3334 20 23.3334C18.6193 23.3334 17.5 22.2141 17.5 20.8334C17.5 19.4527 18.6193 18.3334 20 18.3334C21.3807 18.3334 22.5 19.4527 22.5 20.8334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.b3dbe2f96a91f41e1936a86105afe6b3.svg";
export { ForwardRef as ReactComponent };